const getSingleQueryParam = (value?: string | string[]): string | undefined =>
  (Array.isArray(value) ? value[0] : value) || undefined

export default getSingleQueryParam
